<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.29304 17.3717C7.00151 17.6634 6.61997 17.8206 6.21622 17.8429L4.66819 17.8876L0.0690875 13.4676L0.113845 11.7624C0.136399 11.3587 0.293354 10.9772 0.585052 10.6855L7.28876 3.99585L13.9785 10.6856L7.29304 17.3717Z"
    />
    <path
      d="M15.3927 9.27132L17.5457 7.11812C18.1514 6.51228 18.1514 5.50267 17.5457 4.89684L13.0587 0.454373C12.453 -0.151458 11.4435 -0.151458 10.8377 0.454373L8.70446 2.58312L15.3927 9.27132Z"
    />
    <path
      d="M1.61717 18H1.57226C1.14596 18 0.742247 17.8205 0.473079 17.5513C0.15899 17.2372 -0.020506 16.8109 0.00187211 16.3846L0.0467852 14.7018L3.41198 17.9551L1.61717 18Z"
    />
  </svg>
</template>
